var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 61,
    viewBox: "0 0 43 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 13.3376L0.791992 11.0613V47.2474L4.88096 49.5178L6.23704 48.9401L19.8784 56.4765V57.8071L23.978 60.0833V23.8972L19.8784 21.6209L21.2344 20.802L6.23704 12.5276L4.8916 13.3376Z",
    fill: "#C6C6C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8915 13.3375L6.23694 12.5276L6.23674 22.4994L11.1041 25.1552L10.6246 38.173L6.23694 40.6074V48.9401L4.88086 49.5177L4.8915 13.3375Z",
    fill: "#6F6F6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.791992 11.0613L19.0227 0.916748L42.2087 13.7527L23.978 23.8973L19.8784 21.621L21.2344 20.8021L6.23704 12.5277L4.8916 13.3376L0.791992 11.0613Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8785 40.016V45.2558L10.3477 39.994L8.72656 33.9758L19.8785 40.016Z",
    fill: "#575756"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8785 29.89V35.1299L10.3477 29.868L8.72656 23.8499L19.8785 29.89Z",
    fill: "#575756"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2373 40.6076L9.94584 38.55L19.8783 44.027L19.8786 48.144L6.2373 40.6076Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8785 34.9826V40.2224L10.3477 34.9605L8.72656 28.9424L19.8785 34.9826Z",
    fill: "#575756"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72656 28.9389L9.94568 28.2625L19.8782 33.7395L19.8785 35.0902L8.72656 28.9389Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72656 33.9759L9.94568 33.2996L19.8782 38.7766L19.8785 40.1273L8.72656 33.9759Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0038 23.8973L23.9775 60.0834L42.2082 49.9388V13.7527L23.9775 23.8973",
    fill: "#6F6F6E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.0801 34.0701L22.702 34.9851V31.3095L21.0801 30.3997V34.0701Z",
    fill: "#575756"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.0801 39.2427L22.702 40.1577V36.4821L21.0801 35.5723V39.2427Z",
    fill: "#575756"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.0801 44.3408L22.702 45.2558V41.5802L21.0801 40.6704V44.3408Z",
    fill: "#575756"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectram);
export default __webpack_public_path__ + "static/media/electram.fcdd995014a12df359eb3f2105344ee7.svg";
export { ForwardRef as ReactComponent };